import { render, staticRenderFns } from "./GdCustomRadio.vue?vue&type=template&id=338175ca"
import script from "./GdCustomRadio.vue?vue&type=script&lang=js"
export * from "./GdCustomRadio.vue?vue&type=script&lang=js"
import style0 from "./GdCustomRadio.vue?vue&type=style&index=0&id=338175ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports